import React from "react";

const AddressesPage: React.FC = () => {
  return <div>Addresses Page Content</div>;
};

export default AddressesPage;
